import React, { useState } from 'react';
import Chart from 'react-apexcharts';

const AdminAreaChart = ({ graphdata }) => {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  // Prepare data for the chart
  const salesData = months.map((month) => graphdata?.[month] || 0); // Map months to data or default to 0

  const chartData = {
    series: [
      {
        name: 'Sales',
        data: salesData,
      },
    ],
    options: {
      chart: {
        type: 'area',
        height: 350,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        categories: months.map((month) => month.slice(0, 3)), // Display shortened month names (e.g., Jan, Feb)
        title: {
          text: 'Months',
        },
      },
      yaxis: {
        title: {
          text: 'Sales',
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.2,
          stops: [0, 90, 100],
        },
      },
      tooltip: {
        x: {
          format: 'MMM',
        },
      },
      legend: {
        position: 'top',
      },
    },
  };

  return (
    <div style={{ backgroundColor: '#fff', padding: '22px', borderRadius: '30px' }} className="area-chart-container">
      <h6 style={{ fontSize: '18px', fontWeight: '600' }}>SALES OVER THE MONTH</h6>
      <div style={{ height: '350px' }}>
        <Chart options={chartData.options} series={chartData.series} type="area" height={350} />
      </div>
    </div>
  );
};

export default AdminAreaChart;
